@if (loading) {
    <div class="mt-1 text-muted"><i class="fal fa-fw fa-spin fa-spinner"></i> Checking availability...</div>
}

@if (!loading && available !== undefined) {
    <div class="mt-1"
         [ngClass]="{ 'text-success': available, 'text-danger': !available }">
        <i class="fal fa-fw"
           [ngClass]="{ 'fa-check': available, 'fa-xmark': !available }"></i>
        {{ text }}
        <ng-container [ngTemplateOutlet]="projectedContent"></ng-container>
    </div>
}

<ng-template #projectedContent>
    <ng-content></ng-content>
</ng-template>
